import { styled } from 'styled-components'

import { Cover } from '@/lib/mixins'

export const LoaderWrapper = styled.div`
  ${Cover()}
  z-index: 1000;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`

export const LoaderText = styled.div`
  position: relative;
  max-width: 75%;
  margin-top: 48px;
  color: white;
`

export const LoaderBackdrop = styled.div`
  ${Cover()}
  background-color: rgba(0, 0, 0, 0.6);
`
